import React, { useState } from 'react'
import { useAppDispatch } from '../../Hooks';
import { searchByName } from '../../redux/Actions';

export const Search = () => {
  const dispatch = useAppDispatch();

  const [name, setName] = useState<string>('');

  const handlerSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch<any>(searchByName(name));
    setName("");
  };

  const handlerInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setName(e.target.value);
  };
  
  return (
    <div className='search__container' >
      <form onSubmit={(e) => handlerSubmit(e)} >
        <div>
          <input 
            type="text"
            value={name}
            placeholder='Search country...'
            onChange={(e) => handlerInputChange(e)}
            className='search__container__input'
          />
          <button type='submit' className='search__container__btn' >Buscar</button>
        </div>
      </form>
    </div>
  );
}
